import { render, staticRenderFns } from "./CreationEvent.vue?vue&type=template&id=b28175c2&scoped=true&"
import script from "./CreationEvent.vue?vue&type=script&lang=js&"
export * from "./CreationEvent.vue?vue&type=script&lang=js&"
import style0 from "./CreationEvent.vue?vue&type=style&index=0&id=b28175c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28175c2",
  null
  
)

export default component.exports